import { render, staticRenderFns } from "./DetailLaporanBpkbMacet.vue?vue&type=template&id=0c4bf3fa&scoped=true&"
import script from "./DetailLaporanBpkbMacet.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanBpkbMacet.vue?vue&type=script&lang=js&"
import style0 from "./DetailLaporanBpkbMacet.vue?vue&type=style&index=0&id=0c4bf3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4bf3fa",
  null
  
)

export default component.exports